// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// We disable linting here, otherwise 'unused vars' and 'no new' will get thrown unnecessarily
/* eslint-disable */
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'
import interceptors from './api/interceptors'
import Vuex from 'vuex'
import axios from 'axios'

import {VueFeatherIconsSsr as icon} from 'vue-feather-icons-ssr'
import './assets/css/hokodo-bootstrap.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/custom.css'
import VuePassword from 'vue-password'
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.component('icon', icon)
Vue.component(VuePassword)
Vue.use(VueClipboard)

interceptors()

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js